export * from './wall-type-3.component'